module.exports = __webpack_public_path__ + "img/W7027-thumb.02db7300.jpg";